<template>
  <div>
    <div class="chat-panel d-flex flex-column py-3 gap-3" id="chat-panel" ref="chatPanel">
      <div class="row position-relative" :class="!message.deleted_at && 'no-gutters'" v-for="(message) in messages"
        :key="message.id">
        <div v-if="message.deleted_at" class="message-deleted position-relative font-small">
          <span>メッセージを削除しました。</span>
          <bookmark v-if="!isBookmark" :is-bookmark="message.bookmark"
            :on-bookmark="() => updateBookmark(message.id, message.bookmark)" class="position-absolute delete-bookmark" />
        </div>
        <div v-else class="content-message">
          <div :class="`content-message-${message.sent_by_type == management_type ? 'left' : 'right'}`">
            <div class="information-message d-flex align-items-center mb-2"
              :class="`justify-content-${message.sent_by_type == management_type ? 'start' : 'end'}`">
              <div class="message-time">{{ $moment(message.created_at).format('yyyy/MM/DD HH:mm:ss') }}</div>
              <div>{{ message.sent_by_type }}</div>
              <div>{{ message.sent_by }}</div>
              <bookmark v-if="!isBookmark" :is-bookmark="message.bookmark"
                :on-bookmark="() => updateBookmark(message.id, message.bookmark)" />
            </div>
            <div @click="addShowDeleteBtn(message)"
              :class="`chat-bubble chat-bubble--${message.sent_by_type == management_type ? 'left' : 'right'} ${message.isOwner ? 'cursor-pointer' : ''}`">
              <div class="message-description">
                <div class="m-0 break-space">{{ message.message }}</div>
                <div v-if="message.talk_file_data" class="message-file cursor-pointer" @click="(event) => downloadFile(message.talk_file_data, event)">
                  {{ message.talk_file_data.file_name }}
                </div>
              </div>
            </div>
            <button v-if="idMessageShowDelBtn === message.id" type="button" class="btn btn-light position-absolute"
              :class="`btn-delete-${message.sent_by_type == management_type ? 'left' : 'right'}`"
              @click="deleteMessage(message.id)">削除</button>
          </div>
        </div>
      </div>
    </div>
    <show-error-upload-modal ref="showErrorModal" />
  </div>
</template>
  
<script>
import ShowErrorUploadModal from '@/views/molecules/modals/ShowErrorUploadModal';
import Bookmark from '@/views/atoms/Bookmark';

export default {
  name: "ChatContentList",
  components: {
    ShowErrorUploadModal,
    Bookmark,
  },
  props: {
    isBookmark: {
      type: Boolean,
      default: false,
    },
    messages: {
      type: Array,
      default: () => [],
    },
    issuanceRequestId: {
      type: String,
      default: '',
    },
  },
  inject: [
    '$constant',
    '$moment',
  ],
  data() {
    return {
      idMessageShowDelBtn: null,
      management_type: this.$constant.MANAGEMENT_TYPE,
    }
  },
  watch: {
    messages() {
      this.idMessageShowDelBtn = null;
    },
  },
  methods: {
    loadTalkMessage() {
      return this.$store.dispatch('issuance_request_form/loadTalkMessage', {
        issuanceRequest: this.issuanceRequestId,
      })
      .catch((error) => {
        this.$refs.showErrorModal.show(error);
      });
    },
    updateBookmark(id, bookmark) {
      this.$store.dispatch('issuance_request_form/updateBookmark', {
        issuanceRequestTalk: id,
        issuanceRequest: this.issuanceRequestId,
        bookmark: !bookmark,
      })
        .then(() => {
          this.loadTalkMessage();
        })
        .catch((error) => {
          this.$refs.showErrorModal.show(error);
        })
    },
    deleteMessage(id) {
      this.$store.dispatch('issuance_request_form/deleteTalk', {
        issuanceRequestTalk: id,
        issuanceRequest: this.issuanceRequestId,
      })
        .then(() => {
          this.loadTalkMessage();
          this.idMessageShowDelBtn = null;
        })
        .catch((error) => {
          this.$refs.showErrorModal.show(error);
        })
    },
    downloadFile(payload, event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      this.$store.dispatch('issuance_request_form/downloadTalkFile', {
        ...payload,
        issuanceRequest: this.issuanceRequestId,
      })
      .catch((error) => {
        this.$refs.showErrorModal.show(error);
      })
    },
    addShowDeleteBtn(message) {
      if (!this.isBookmark && !message.deleted_at && message.isOwner) {
        this.idMessageShowDelBtn = this.idMessageShowDelBtn === message.id ? null : message.id;
      }
    },
  },
}
</script>

<style scoped>
.chat-bubble {
  padding: 4px 8px;
  border-radius: 9px;
  position: relative;
  display: inline-block;
}
.chat-bubble::after {
  content: '';
  position: absolute;
  top: 50%;
  width: 0;
  height: 0;
  border: 20px solid transparent;
  border-bottom: 0;
  margin-top: -10px;
}
.content-message-left {
  max-width: 100%;
}
.chat-bubble--left {
  float: left;
  background: #b5e2f7;
  max-width: 100%;
}
.chat-bubble--left::before,
.chat-bubble--left::after {
  content: "";
  position: absolute;
  border-top: 8px solid transparent;
  border-right: 22px solid #b5e2f7;
  border-bottom: 8px solid transparent;
  top: 31%;
  left: 4px;
  margin-left: -25px;
}
.chat-bubble--left::after {
  margin-top: 0px;
  border-right: 22px solid #b5e2f7;
  margin-left: -40px;
}
.chat-bubble--right::after {
  right: 0;
  border-right: 0;
  margin-right: -20px;
  border-top: 10px solid transparent;
  border-left: 25px solid #bff5e0;
  border-bottom: 10px solid transparent;
}
.chat-bubble--right {
  background: #bff5e0;
}
.information-message {
  column-gap: 8px;
  font-size: 14px;
}
.content-message-right,
.chat-bubble--right {
  float: right;
  max-width: 100%;
}
.no-gutters {
  margin: 0 10px;
}
.chat-panel {
  height: 275px;
  overflow-y: auto;
  overflow-x: hidden;
}
.cursor-pointer {
  cursor: pointer;
}
.btn-delete-left {
  clear: both;
  float: left;
  left: 1rem;
  bottom: -2rem;
  z-index: 2;
  padding: 2px 8px;
}
.btn-delete-right {
  width: fit-content;
  clear: both;
  float: right;
  right: 1rem;
  bottom: -2rem;
  z-index: 2;
  padding: 2px 8px;
}
.message-description {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 24px;
}
.message-file {
  color: #3d3dcbf2;
  font-size: 14px;
  white-space: break-spaces;
}
.message-deleted {
  text-align: center;
  background-color: #ededed;
}
.delete-bookmark {
  top: 4px;
  right: 35px;
}
.break-space {
  white-space: break-spaces;
}
</style>
